import { parseSearchWith } from "@tanstack/react-router";
import { z } from "zod";

export const extractionListSearchSchema = z.object({
  fileId: z.string().optional(),
  fileIds: z
    .array(z.string())
    .transform((ids) => [...new Set(ids)])
    .optional(),
  search: z.string().optional(),
  extractMode: z.enum(["text", "table", "metadata"]).optional(),
  tmplId: z.string().optional(),
  status: z.string().optional(),
  scope: z.enum(["all", "mine"]).optional(),
  page: z.number().int().positive().optional(),
  pageSize: z.number().int().positive().optional(),
});

export type ExtractionListSearch = z.infer<typeof extractionListSearchSchema>;

/** 返回地址只允许抽取列表，且仅恢复本列表支持的查询状态。 */
export function parseExtractionReturnTo(value?: string): ExtractionListSearch | undefined {
  if (!value?.startsWith("/") || value.startsWith("//")) return undefined;
  try {
    const url = new URL(value, "https://extraction.invalid");
    if (url.origin !== "https://extraction.invalid" || !["/data-center/extraction", "/data-center/extraction/"].includes(url.pathname)) return undefined;
    const result = extractionListSearchSchema.safeParse(parseSearchWith(JSON.parse)(url.search));
    return result.success ? result.data : undefined;
  } catch {
    return undefined;
  }
}
